import React from "react";
import { Box, Grid, Rating, Stack } from "@mui/material";
import LandingHeader from "../../../layout/header";
import Footer from "../../../layout/footer";
import { BlueBox, BtnAccess, ReviewBox } from "../style";
import { RootStyle, Text, Title } from "../style";
import { AboutGrid, AboutText, AboutTitle } from "../style";
import AboutImg from "../../../images/landing/inventory module.png";
import Icon1 from "../../../images/landing/inventory icon 1.png";
import Icon2 from "../../../images/landing/inventory icon 2.png";
import Icon3 from "../../../images/landing/inventory icon 3.png";
import PartnerLogo from "../../../images/landing/super.png";
import { Link } from "react-router-dom";
import AccessNow from "../AccessNow";
import { InnerBlueBox } from "../style";

function InventoryModule() {
  return (
    <Box sx={{ background: "#fff" }}>
      <LandingHeader />
      <RootStyle sx={{ my: "40px" }}>
        <Stack spacing="64px">
          <BlueBox sx={{ minHeight: "163px" }}>
            <InnerBlueBox sx={{ p: "0 0 0 32px", maxHeight: "163px" }}>
              <Grid container>
                <AboutGrid item md={7} xs={12}>
                  <AboutTitle>Inventory Management System</AboutTitle>
                  <Link to="/inventory/login">
                    <BtnAccess>Access Now</BtnAccess>
                  </Link>
                </AboutGrid>
                <Grid item md={5} xs={12} sx={{ order: { xs: 1, md: 2 } }}>
                  <Box>
                    <img
                      style={{ maxHeight: "163px" }}
                      width="100%"
                      src={AboutImg}
                      alt=""
                    />
                  </Box>
                </Grid>
              </Grid>
            </InnerBlueBox>
          </BlueBox>

          <Stack spacing="40px" alignItems="center">
            <AboutTitle sx={{ color: "#60656C", textAlign: "center" }}>
              Take control of your inventory with our comprehensive Inventory
              Management Features.
            </AboutTitle>
            <img src={Icon1} alt="" />
          </Stack>

          <Box
            sx={{
              background: "#FFFEED",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={8} xs={12} order={{ xs: 2, md: 1 }}>
                <AboutText>This powerful tool empowers you to:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b> Create and manage multiple warehouses:</b> Organise
                      your inventory across different locations, optimising
                      storage and fulfillment processes.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b> Add items to specific warehouses: </b> Track stock
                      levels accurately with precise location information.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Transfer items between warehouses: </b> Seamlessly move
                      inventory between locations as needed.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Enhanced organisation with Racks:</b> Create and manage
                      racks and sub-racks within your warehouses for further
                      item categorisation and granular control.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Improved item tracking:</b> Assign items to specific
                      racks for instant visibility and efficient inventory
                      management.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Streamlined operations:</b> Optimise your warehouse
                      workflow with automated inventory updates when items are
                      sold.
                    </AboutText>
                  </li>
                </ul>
              </Grid>
              <Grid item md={4} xs={12} order={{ xs: 1, md: 2 }}>
                <img width="100%" src={Icon2} alt="" />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              background: "#FFFEED",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={4} xs={12}>
                <img width="100%" src={Icon3} alt="" />
              </Grid>
              <Grid item md={8} xs={12}>
                <AboutText>Benefits:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Reduced Costs:</b> Minimise storage space and optimise
                      inventory levels, leading to cost savings.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Incease Efficiency: </b>
                      Streamline your warehouse operations with faster item
                      picking and fulfillment.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Improved Accuracy: </b> Eliminate inventory
                      discrepancies with accurate tracking and location
                      information.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Enhanced decision-making:</b> Gain valuable insights
                      into your inventory data for informed business decisions.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Better Organisation:</b> Organise your inventory
                      logically for increased productivity and efficiency.
                      management.
                    </AboutText>
                  </li>
                </ul>
                <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                  With the Inventory Management Module, you can gain complete
                  control over your inventory, optimise your warehouse
                  operations, and ultimately, achieve greater profitability.
                </AboutText>
              </Grid>
            </Grid>
          </Box>

          <ReviewBox>
            <Grid container spacing="16px">
              <Grid
                item
                md={6}
                xs={12}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Stack>
                  <Text sx={{ color: "#fff" }}>
                    "Managing our inventory has never been smoother since we
                    integrated ManageKaro into our operations at Super Machinery
                    Store. I am Mr. Haseeb, and I can confidently say that this
                    system has transformed the way we handle our stock.The
                    efficiency that ManageKaro brings to inventory management is
                    unparalleled. The automated features, especially in tracking
                    stock levels and reordering, have significantly reduced the
                    manual workload for our team. This not only saves time but
                    has also virtually eliminated errors in our inventory
                    records.”
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <Rating name="simple-controlled" value={5} />
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={PartnerLogo} alt="" />
                  <Box>
                    <Title sx={{ color: "#fff" }}>SuperMachinery Store</Title>
                    <Title sx={{ color: "#fff", fontSize: "24px" }}>
                      Mr Haseeb
                    </Title>
                    <Text sx={{ color: "#fff", fontStyle: "italic" }}>
                      City Saddar Road, Nanakpura, Rawalpindi
                    </Text>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </ReviewBox>

          <AccessNow />
        </Stack>
      </RootStyle>
      <Footer />
    </Box>
  );
}

export default InventoryModule;
